enum EPlanCategory {
  BASE = 'BASE',
  PARKING = 'PARKING',
  BUSINESS = 'BUSINESS',
  CHEAPEST = 'CHEAPEST',
  BUILDER = 'BUILDER',
  APPLICATION = 'APPLICATION',
  PHP = 'PHP',
  PARTNER = 'PARTNER',
  WITHOUT_PLAN = 'WITHOUT_PLAN',
  OTHER = 'OTHER',
  MAIL = 'MAIL',
}

export default EPlanCategory
